module.exports = __webpack_public_path__ + "img/xls.a3b326d4.png";